import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { TournamentReportPeriodForm } from '../TournamentReportPeriodForm';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

export function UnionMemberSchoolsStatisticsReportForm(props: Props) {
  return (
    <TournamentReportPeriodForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_MEMBER_SCHOOLS_STATISTICS}
      description="Review tournament participation statistics for union member schools during the selected period."
      toggles={[
        {
          field: 'isShowZero',
          label: 'Show non-participants',
          hint: 'Include schools that did not participate during the selected period.',
          initialValue: true
        },
        {
          field: 'isShowNonZero',
          label: 'Show participants',
          hint: 'Include schools that participated during the selected period.',
          initialValue: true
        }
      ]}
    />
  );
}
